import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import PreLoader from "../../../../core/common/preLoader";
import SectionTreeView from "./sectionsTreeView";
import { TreeDataNode } from "antd";
import { useSearchParams } from 'react-router-dom';
import useFetch from "../../../../hooks/useFetch";
import { API } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import { Syllabus } from "../../../../types/dataModel";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import { useAccess } from "../../../../hooks/accessContext";
import { ids } from "../../../../core/common/selectoption/selectoption";
import StudyMaterialModal from "./studyMaterialModal";

const ModifySyllabusDetails = () => {
  const { hasAcademicMgntEdit }  = useAccess()
  const navigation = useNavigate();
  const [treeData, setTreeData] = useState<TreeDataNode[]>([]);
  const [searchParams] = useSearchParams();
  const { isLoading, error, callFetch } = useFetch();
  const [syllabus, setSyllabus] = useState<Syllabus>();
  const [syllabusId, setSyllabusId] = useState<number>();
  const [msgBox, setMsgBox] = useState<any>({
    msg: "",
    error: false
  });
  const [selectedNode, setSelectedNode] = useState<any>(null);

  useEffect(() => {
      let id = searchParams.get("id")
      if (id){
        fetch(id)
        setSyllabusId(parseInt(id));
      }
  }, [searchParams]);

  useEffect(() => {
      if(error){
        if(error.response?.data){
          setMsgBox({msg: error.response?.data, error: true})
        } else{
          setMsgBox({msg:'Something went wrong please try again later.', error: true})
        }
      }
  }, [error]);

  // useEffect(() => {
  //     if(data && status && status < 299){
  //       if(data?.details){
  //         setTreeData(data?.details?.units)
  //         setSyllabus(data)
  //       } else {
  //         setMsgBox({msg: "Updated Successfully", error: false})
  //       }
  //     }
  //  }, [data]);

  const fetch = (id:string) => {
      callFetch(`${API.SYLLABUS}/${id}`,
        'GET',
        getAPIHeaders(),
        null,
        null
    ).then((res)=>{
      setSyllabus(res)
      if(res?.details){
        setTreeData(res?.details?.units)
      }
    }).catch((err)=>{
    });
  }


  const handleTreeDataChange = (data:any) => {
    let newSyllabus = {
      ...syllabus,
      details: {
        ...syllabus?.details,
        units: data
      }
    }

    callFetch(API.SYLLABUS,
      'PUT',
      getAPIHeaders(),
      null,
      {
        id: syllabusId,
          ...newSyllabus
      }
    ).then((res) => {
      fetch(syllabusId?.toString() || '');
      setMsgBox({msg: "Updated Successfully", error: false})
    }).catch((err)=>{
    })
  }

  const handleSubmit = (event:any) => {
      event.preventDefault()
      setMsgBox({msg:"", error: false})
      callFetch(API.SYLLABUS,
            'PUT',
            getAPIHeaders(),
            null,
            {
              id: syllabusId,
                ...syllabus
            }
      ).then(()=>{
        setMsgBox({msg: "Updated Successfully", error: false})
      }); 
  }

  const handleDeleteNode = (node:any) => {
      let endpoint = "";
      if (node.nodeType === 'SECTION'){
        endpoint = API.MODIFY_SECTION.replace(':sectionId', node.id?.toString() || '')
      } else if (node.nodeType === 'UNIT'){
        endpoint = API.MODIFY_UNIT.replace(':unitId', node.id?.toString() || '')
      }
      setMsgBox({msg:"", error: false})
      callFetch(endpoint,
            'DELETE',
            getAPIHeaders(),
            null,
            null,
      ).then(()=>{
        fetch(syllabusId?.toString() || '');
        setMsgBox({msg: "Updated Successfully", error: false})
      }); 
  }

  const handleAddNode = (node:any) => {
    setMsgBox({msg:"", error: false})
    let endpoint = ""
    if(node.parentNodeType === 'SYLLABUS'){
      endpoint = API.CREATE_UNIT.replace(':syllabusId', syllabusId?.toString() || '')
    } else if(node.parentNodeType === 'UNIT'){
      endpoint = API.CREATE_SECTION.replace(':unitId', node.parentId?.toString() || '')
    } else if(node.parentNodeType === 'SECTION'){
      endpoint = API.CREATE_SUB_SECTION.replace(':sectionId', node.parentId?.toString() || '')
    } 
    callFetch(endpoint,
          'POST',
          getAPIHeaders(),
          null,
          {
            name: node.title,
          }
    ).then(()=>{
      fetch(syllabusId?.toString() || '');
      setMsgBox({msg: "Updated Successfully", error: false})
    });   
  }

  const handleEditNode = (node:any) => {
    let endpoint = "";
    if (node.nodeType === 'SECTION'){
      endpoint = API.MODIFY_SECTION.replace(':sectionId', node.id?.toString() || '')
    } else if (node.nodeType === 'UNIT'){
      endpoint = API.MODIFY_UNIT.replace(':unitId', node.id?.toString() || '')
    }
    setMsgBox({msg:"", error: false})
    callFetch(endpoint,
          'PUT',
          getAPIHeaders(),
          null,
          {
            id: node.id,
            name: node.title,
          }
    ).then(()=>{
      fetch(syllabusId?.toString() || '');
      setMsgBox({msg: "Updated Successfully", error: false})
    }); 
  }

  const handleNodeClick = (node: any) => {

    if (!node.nodeType) {
      let nodeData = {
        id: syllabusId,
        title: syllabus?.title || 'Syllabus',
        nodeType: 'SYLLABUS',
        description: syllabus?.description
      };
      setSelectedNode(nodeData);
    } else {
      setSelectedNode(node);
    }
  };

  const renderMsgBox = () => {
    return (
      <div>
      { msgBox?.msg  
          ?
          msgBox?.error
          ?
            <>
              <i className="ti ti-alert-triangle text-danger" />  
              <span className='text-danger'> {msgBox?.msg} </span> 
            </> 
          :
            <>
              <i className="ti ti-thumb-up text-success" />  
              <span className='text-success'> {msgBox?.msg} </span> 
            </> 
          : <></>
      }
    </div>
    )
  }

  return (
    <>
      <PreLoader showLoader={isLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">{syllabus?.title}</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Academics</li>
                  <li className="breadcrumb-item">                    
                    <Link to={all_routes.syllabus}>
                      Syllabus
                    </Link> 
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={()=>{
                    navigation(`/academics/syllabus`);
                  }}
                >
                  <i className="ti ti-arrow-left me-2" />
                  Back to Syllabus
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Syllabus Details</h5>
            </div>
            <div className="card-body p-10">
                <SectionTreeView
                    heading={syllabus?.title}
                    readonly={!hasAcademicMgntEdit()} 
                    data={treeData} 
                    onSave={handleTreeDataChange}
                    onNodeClick={handleNodeClick}
                    onStateUpdate={(data:any)=>{
                      setSyllabus({
                        ...syllabus,
                        details: {
                          ...syllabus?.details,
                          units: data
                        }
                      })
                    }}
                    onAddNode={handleAddNode}
                    onDeleteNode={handleDeleteNode}
                    onEditNode={handleEditNode}
                />
            </div>
            <div className="card-footer d-flex justify-content-between align-items-center">
              <>
              {renderMsgBox()}
              </>
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo/>
        </div>
      </div>
      {/* /Page Wrapper */}
      
      {/* Study Material Modal */}
      {syllabusId && 
        <StudyMaterialModal
        syllabusId={syllabusId}
        data={selectedNode}
        refresh={() => {
          // Refresh syllabus data if needed
          if (syllabusId) {
            fetch(syllabusId.toString());
          }
        }}
      />}
    </>

  );
};


export default ModifySyllabusDetails;